// extracted by mini-css-extract-plugin
export default {"container":"document-metadata_container__2EjzR"};